import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { jobEndpoints } from '@/lib/api/endpoints';
import { jobKeys } from '@/lib/queryKeys';
import type { AuditLog } from '@/types/auditLog';

export type JobActivityKind =
  | 'audit'
  | 'lifecycle'
  | 'invoice'
  | 'review'
  | 'visit_completed'
  | 'visit_skipped';

export interface JobActivityEvent {
  kind: JobActivityKind;
  title: string;
  detail: string | null;
  /** ISO timestamp. */
  at: string;
  /** Full audit data when this activity is backed by an audit record. */
  audit?: AuditLog;
}

/**
 * Reverse-chron job activity feed: audit entries plus invoice, review, and
 * visit events for the Activity tab.
 */
export function useJobActivity(jobId: string, enabled = true) {
  return useApiQuery<JobActivityEvent[]>({
    queryKey: jobKeys.activity(jobId),
    queryFn: () => apiGet<JobActivityEvent[]>(operationsClient, jobEndpoints.activity(jobId)),
    enabled: Boolean(jobId) && enabled,
    showErrorToast: false,
  });
}
